import React from 'react';
import { IconButton } from '../core/IconButton.jsx';
import { Badge } from '../core/Badge.jsx';
import { PlayButton } from './PlayButton.jsx';
import { SkipButton } from './SkipButton.jsx';
import { Scrubber } from './Scrubber.jsx';
import { SpeedControl } from './SpeedControl.jsx';
import { TimerControl } from './TimerControl.jsx';
import { CoverTile } from '../media/CoverTile.jsx';

/**
 * Web bottom player bar (fixed, always dark).
 * Controls: 后退5s · 播放/暂停 · 前进10s · 下一首 | 进度 | 倍速 · 定时 · 字幕 · 播放列表
 */
export function PlayerBar({
  episode,
  playing = false,
  currentTime = 0,
  duration = 0,
  speed = 1,
  timer = null,
  queueOpen = false,
  captionsOn = false,
  showCaptionsButton = false,
  onToggle,
  onSkip,
  onNext,
  onSeek,
  onSpeedChange,
  onTimerChange,
  onQueueToggle,
  onCaptionsToggle,
  className = '',
  style,
}) {
  return (
    <div className={`bjl-playerbar ${className}`} style={style} data-theme="dark">
      <div className="bjl-playerbar__meta">
        {episode ? (
          <>
            <span className="bjl-playerbar__cover">
              {episode.cover ? <img src={episode.cover} alt="" /> : <CoverTile vol={episode.vol} size={52} seed={episode.id} />}
            </span>
            <span style={{ minWidth: 0 }}>
              <span className="bjl-playerbar__title">{episode.title}</span>
              <span className="bjl-playerbar__sub">
                {episode.vol != null ? <span style={{ fontFamily: 'var(--font-mono)' }}>Vol.{episode.vol}</span> : null}
                {episode.memberOnly ? <Badge variant="member" /> : null}
              </span>
            </span>
          </>
        ) : null}
      </div>

      <div className="bjl-playerbar__center">
        <div className="bjl-playerbar__controls">
          <SkipButton direction="back" onSkip={onSkip} />
          <PlayButton playing={playing} size={44} onClick={onToggle} />
          <SkipButton direction="forward" onSkip={onSkip} />
          <IconButton icon="skip_next" label="下一首" onClick={onNext} />
        </div>
        <Scrubber value={currentTime} duration={duration} onSeek={onSeek} />
      </div>

      <div className="bjl-playerbar__actions">
        <SpeedControl value={speed} onChange={onSpeedChange} />
        <TimerControl value={timer} onChange={onTimerChange} />
        {showCaptionsButton ? (
          <IconButton icon="closed_caption" label="对话字幕" active={captionsOn} onClick={onCaptionsToggle} />
        ) : null}
        <IconButton icon="queue_music" label="播放列表" active={queueOpen} onClick={onQueueToggle} />
      </div>
    </div>
  );
}
